import React from 'react';
import { Modal, Box } from '@material-ui/core';
import Text from 'components/shared/Text';
import styles from './styles.module.css';
import { checkmarkCircleOutline } from 'assets/newIcons';

const boxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  padding: '20px 40px 40px 20px',
  boxShadow: 24,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '30px',
  height: '150px',
  width: '280px',
};

export default function Popup({ openPopup, handleClosePopup }) {
  return (
    <Modal open={openPopup} onClose={handleClosePopup}>
      <Box sx={boxStyle}>
        <img height={50} width={50} alt="" src={checkmarkCircleOutline} />
        <Text className={styles.imgHeading}>
          Your notification <br /> preferences have been <br /> saved.
        </Text>
      </Box>
    </Modal>
  );
}
